// WCAG 2.5.8 (Target Size, Minimum) requires a >=24px hit area on every axis. The
// visible text/icon stays at its designed line height, so the extra height comes
// from padding offset by an equal negative margin — the interactive area grows to
// 24px while the box still occupies its original footprint in a dense table cell.
const TARGET_SIZE_INSET = '4px';

export const callLinkStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: `${TARGET_SIZE_INSET} 0`,
  margin: `-${TARGET_SIZE_INSET} 0`,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  textAlign: 'left',
  color: 'inherit',
  textDecoration: 'none',
  '&:hover, &:focus-visible': {
    color: ({ palette }) => palette.primary.main,
    textDecoration: 'underline',
  },
};

export const callIconStyles = {
  flexShrink: 0,
  lineHeight: 0,
  color: ({ palette }) => palette.primary.main,
};

export const callIconButtonStyles = {
  padding: '4px',
  color: ({ palette }) => palette.primary.main,
};
